import { ApiError, SessionExpiredError } from "@/lib/api-client";

export const DOWNLOAD_UNAVAILABLE =
  "This download is no longer available. Ask for it again from the photos.";
/** What the tray says for a zip removed after its retention (`ZIP_RETENTION_MS`, 7 days). */
export const DOWNLOAD_EXPIRED = "Downloads are kept for 7 days. Ask for it again from the photos.";
export const DOWNLOAD_NOT_STARTED = "The download could not be started. Try again.";
export const DOWNLOAD_OFFLINE = "The download could not be started. Check your connection.";
export const SIGNED_OUT = "You are signed out. Sign in again to see your downloads.";
export const DOWNLOADS_FAILED = "Could not check your downloads.";

/**
 * Asks the server whether a finished zip may still be fetched (`?check=1`: no link, no audit
 * row). Returns the message to show when it may not, or null when the download can go ahead.
 */
export async function checkDownload(
  url: string,
  fetcher: (url: string) => Promise<Response> = fetch,
): Promise<string | null> {
  try {
    const res = await fetcher(`${url}?check=1`);
    if (res.status === 404) return DOWNLOAD_UNAVAILABLE;
    if (res.status === 401) return SIGNED_OUT;
    if (!res.ok) return DOWNLOAD_NOT_STARTED;
    return null;
  } catch {
    return DOWNLOAD_OFFLINE;
  }
}

/** What the tray says when the list of downloads can not be loaded. */
export function downloadsErrorMessage(error: unknown): string {
  if (error instanceof SessionExpiredError) return SIGNED_OUT;
  if (error instanceof ApiError && error.status === 401) return SIGNED_OUT;
  return DOWNLOADS_FAILED;
}

export function isSignedOut(error: unknown): boolean {
  return downloadsErrorMessage(error) === SIGNED_OUT;
}
